export default{
  powiaty:{
    cards:[
      {
        id: 0,
        img: '/historia/okres_41_44/Bolesław_Zagorny.jpg',
        desc: 'Kpt. Bolesław Zagórny „Jan”'
      },
      {
        id: 1,
        img: '/historia/okres_41_44/Bolesław_Zarzycki.jpg',
        desc: 'Mjr Bolesław Zarzycki „Rojan”'
      },
      {
        id: 2,
        img: '/historia/okres_41_44/Tadeusz_Topor_Wasowski.jpg',
        desc: 'Tadeusz Topór- Wąsowski „Nowicki”'
      },
      {
        id: 3,
        img: '/historia/okres_41_44/Adam_Boryczka.jpg',
        desc: 'Por. Adam Boryczka „Tońko” „Brona”'
      }
    ],
    list:{
      desc:[
        'Komendantem Garnizonu został - mjr dypl. Antoni Olechnowicz „Pohorecki”.',
        'Szefem sztabu kpt. Bolesław Wasilewski „Zosia”, który po przeniesieniu do sztabu Komendy Okręgu Nowogródzkiego miał pseudonim „Zoja”, „Bustromiak”.',
        'Komendantem Dzielnicy „A” - kpt. Bolesław Zagórny „Jan”.',
        'Komendantem Dzielnicy „B” - mjr Władysław Zarzycki „Rojan”.',
        'Komendantem Dzielnicy „C” - mjr Tadeusz Wąsowski „ Nowicki”.',
        'Komendantem Dzielnicy „D” - kpt. Józef Grzesiak „Kmita”.',
        'Komendantem powiatów województwa wileńskiego „Pole” zostaje - mjr inż. Czesław Dębicki „Jarema”.'
      ],
      rejony:[
        'Rejon I - obejmujący powiaty : wileńsko-trocki i święciański, którego dowódcą został mjr Stanisław Marchewka „Lis”.',
        'Rejon II - obejmujący powiaty : brasławski, postawski i głębocki, którego dowódcą został ppor. Waldemar Żaba „Bocian”, a następnie mjr Stefan Świechowski „Sulima”.',
        'Rejon III - obejmujący powiaty: oszmiański, wilejski, mołodeczański, którego dowódcą został kpt.Stefan Zalewski „Skiwski”.'
      ]
    }
  },
  okreg_deleg:{
    cards:{
      part1:[
        {
          id: 0,
          img: '/historia/okres_41_44/Zygmunt_Fedorowicz.jpg',
          desc: 'Zygmunt Fedorowicz "Albin", "Pani Maria", "Józef"'
        },
        {
          id: 1,
          img: '/historia/okres_41_44/Henryk_Jackiewicz.jpg',
          desc: 'Henryk Jackiewicz „Marian”'
        },
        {
          id: 2,
          img: '/historia/okres_41_44/Władysław_Babicki.jpg',
          desc: 'Władysław Babicki „Jerzy”'
        },
        {
          id: 3,
          img: '/historia/okres_41_44/Witold_Pawlikowski.jpg',
          desc: 'Witold Pawlikowski „Rafał”'
        }
      ],
      part2:[
        {
          id: 4,
          img: '/historia/okres_41_44/Wacław_Iszora.jpg',
          desc: 'Wacław Iszora „Wacławski”'
        },
        {
          id: 5,
          img: '/historia/okres_41_44/Adam_Galinski.jpg',
          desc: 'Adam Galiński „Pan P”'
        },
        {
          id: 6,
          img: '/historia/okres_41_44/Wacław_Podbereski.jpg',
          desc: 'Wacław Podbereski „Szary”'
        }
      ]
    },
    list:{
      wilno:[
        'I z-ca Delegata - Henryk Jackiewicz "Marian".',
        'II z-ca Delegata - Jerzy Dobrzański "Maciej".',
        'Biuro Delegata Rządu - kierowanego przez Władysława Babickiego „Jerzy”, a następnie przez Witolda Pawlikowskiego „Rafał”.',
        'Sekretarz Delegata - Wacław Religioni „Marian”.',
        'Inspektorat Samorządowy - kierowany przez Wacława Iszorę „Wacławski”.',
        'Wydział Bezpieczeństwa - kierowany przez Witolda Świerzewskiego „Bartek”, a następnie Kazimierza Protasewicza „Sokół”.',
        'Wydział Informacji i Prasy - kierownikiem był Władysław Babicki” „Jerzy”, poprzednio był kierownikiem Biura Delegata.',
        'Opieki Społecznej - kierowany przez Adama Galińskiego „Adam”, „Pan P”, następnie przez ks. Aleksandra Lachowicza „Leszczyna”.',
        'Wydział Zdrowia - kierowany przez dr Feliksa Kasperowicza „Szczęsny”, „Pan N”, następnie dr Witolda Brynka.',
        'Wydział Oświaty - kierowany przez Jana Bobkę, a jego zastępcą został Stanisław Starościak.',
        'Wydział Przemysłu i Handlu - kierowany przez inż. Władysława Hajdukiewisza.',
        'Wydział Rolnictwa - kierowany przez Ludwika Chomińskiego.',
        'Wydział Sprawiedliwości - kierowany przez Władysława Dmochowskiego.',
        'Wydział Finansowy - kierowany przez Wacława Maurycego Gajewskiego.'
      ],
      rzad:[
        'Sąd Karny Specjalny - przewodniczącym był Jan Radwański „Zygmunt”, „Rawicz”, „Barnaba”.',
        'Łączność zewnętrzna - kurierska, radiowa, szyfrowa były prowadzone przez zespoły ludzi każdorazowo dobieranych.',
        'Komórka Legalizacji - prowadzona przez Wacława Podbereskiego „Szary”, kurier Delegatury Rządu do Delegata Rządu na Kraj w Warszawie.'
      ]
    }
  },
  komenda:{
    cards:{
      part1:[
        {
          id: 0,
          img: '/historia/okres_41_44/Lubosław_Krzeszowski.jpg',
          desc: 'Mjr Lubosław Krzeszowski „Ludwik”'
        },
        {
          id: 1,
          img: '/historia/okres_41_44/Teodor_Cetys.jpg',
          desc: 'Mjr dypl. Teodor Cetys „Sław”'
        },
        {
          id: 2,
          img: '/historia/okres_41_44/Zofia_Dab_Biernacka.jpg',
          desc: 'Zofia Dąb-Biernacka „Jagienka”'
        },
        {
          id: 3,
          img: '/historia/okres_41_44/Barbara_Skarzanka.jpg',
          desc: 'Barbara Skarżanka „Ewa”'
        }
      ],
      part2:[
        {
          id: 4,
          img: '/historia/okres_41_44/Aniela_Dziewulska.jpg',
          desc: 'Aniela Dziewulska „Krystyna”'
        },
        {
          id: 5,
          img: '/historia/okres_41_44/Michal_Warakomski.jpg',
          desc: 'Michał Warakomski „Piotr”'
        },
        {
          id: 6,
          img: '/historia/okres_41_44/Mieczyslaw_Potocki.jpg',
          desc: 'Mjr dypl. Mieczysław Potocki „Węgielny”'
        },
        {
          id: 6,
          img: '/historia/okres_41_44/Jerzy_Bronikowski.jpg',
          desc: 'Kpt. Jerzy Bronikowski „Czarny Jan”'
        }
      ]
    },
    list:{
      obsada:[
        'Komendant Okręgu - ppłk Aleksander Krzyżanowski "Wilk".',
        'Zastępca Komendanta i Szefem Sztabu - ppłk Lubosław Krzeszowski "Ludwik".',
        'Dowódca Oddziału I-go Ogólno-Organizacyjnego i Odtwarzania Wojska Polskiego - ppłk Julian Kulikowski "Witold Drohomirski".',
        'Dowódca Oddziału II-go Wywiadu Operacyjnego - kpt. Stawiej "Otto".',
        'Kontrwywiad - Mirosław Głębocki "Cecylia".',
        'Dowódca Oddziału III-go Operacyjno Szkoleniowego - cc mjr Teodor Cetys "Sław", "Wiking".',
        'Dowódca Oddziału IV-go Kwatermistrzostwo i Służby Logistyczne - mjr dypl. Kazimierz Heilman "Tomasz".',
        'Dowódca Oddziału V-go Łączność Operacyjna - kpt. Stefan Czernik "Orwat".',
        'Łączność z konspiracją - Zofia Dąb-Biernacka "Jagienka".',
        'Łączność z Inspektoratami i Brygadami - Barbara Skarżanka "Ewa".',
        'Łączność wewnętrzna Sztabu Okręgu - Aniela Dziewulska "Krystyna".',
        'Dowódca Oddziału VI-go Biuro Informacji i Prasy - Antoni Kokociński "Juliusz".',
        'Dowódca Oddziału VII-go Legalizacja - Michał Warakomski "Piotr".'
      ],
      inspektoraty:[
        'Dowódcą Inspektoratu "A" obejmującego miasto Wilno i powiat wileńsko- trocki - mjr dypl. Antoni Olechnowicz "Pohorecki” z dwoma podinspektorami: północny',
        'kpt. Emanuel Prokesche "Emka", południowy - kpt. Jerzy Bronikowski "Dzik", „Czarny Jan”.',
        'Oraz garnizon miasta Wilna - mjr Leon Koplewski „Bezmian" "Skarbek".',
        'Szef Sztabu Inspektoratu - mjr Aleksander Wasilewski "Olesiński".',
        'Dowódcą Inspektoratu "BC" obejmującego powiaty święciański, brasławski i dziśnieński - mjr dypl. Mieczysław Potocki "Kamień", "Węgielny".',
        'Szef sztabu - por. Jan Drozdowicz "Gerwazy".',
        'Dowódcą Inspektoratu "F" obejmującego powiaty: oszmiański, wilejski, mołodecki - mjr inż. Czesław Dębicki "Jarema".',
        'Szef Sztabu - kpt. Michał Kwakszys "Kowal".'
      ],
      sztaby:[
        'Szef Sztabu Powstania wewnątrz miasta Wilna - ppłk Lubosław Krzeszowski "Ludwik", oraz sztab Oddziałów w polu.',
        'Szef Sztabu - mjr dypl. Teodor Cetys "Sław".',
        'Dowódca Oddziału I Organizacyjno-Szkoleniowego - kpt. Zbigniew Brodzikowski "Rańcza".',
        'Dowódca Oddziału II Wywiad Operacyjny- popr. Bolesław Nowak "Majewski".',
        'Dowódca Oddziału III Operacyjnego - ppłk Zygmunt Izydor Blumski "Strycharski".',
        'Dowódca Oddziału IV Kwatermistrzostwo - mjr Kazimierz Radzikowski "Robur".',
        'Dowódca Oddziału V Łączności Operacyjnej - kpt. Stefan Czernik "Orwat".',
        'Dowódca Oddziału VI Biuro Informacji i Propagandy - ppor. Leon Lech Bejnar "Nowina" /Paweł Jasienica/.'
      ]
    },
    zgrupowania:[
      {
        id:0,
        title: 'I Zgrupowanie:',
        list:[
          '2. Brygada por. "Kaziuka"',
          '3. Brygada por. "Szczerbca"',
          '5. Brygada por. Łupaszki"',
          '7. Brygada por. "Wilhelma"',
          'Oddział Partyzancki por. „Gozdawy”',
          'Oddział Rozpoznawczy Dowództwa Zgrupowania por. "Groma"'
        ]
      },
      {
        id:1,
        title: 'II Zgrupowanie:',
        list:[
          '1. Brygada por. "Juranda"',
          '4. Brygada por. "Ronina"',
          '23. Brygada por. Światołdycza"',
          '24. Brygada por. "Wawrzeckiego"',
          '36. Brygada por "Wujka"',
          'Oddział "Kedywu" por. "Frycza"',
          'Oddział Rozpoznawczy Dowództwa Zgrupowania por. "Ptasznika"'
        ]
      },
      {
        id:2,
        title: 'III Zgrupowanie:',
        list:[
          '8. Brygada por. "Tura"',
          '9. Brygada, chor. "Małego"',
          '12. Brygada por. "Cerbera"',
          '13. Brygada por. Nietoperza"',
          'Oddział Osłony Dowództwa Zgrupowania por. "Gracza"',
        ]
      }
    ]
  },
  legalizacja:{
    cards:{
      part1:[
        {
          id: 0,
          img: '/historia/okres_41_44/Stanisław_Kialka.jpg',
          desc: 'Stanisław Kiałka „Bolesław”, „Jelonek”'
        },
        {
          id: 1,
          img: '/historia/okres_41_44/Jerzy_Hoppen.jpg',
          desc: 'Prof. Jerzy Hoppen'
        },
        {
          id: 2,
          img: '/historia/okres_41_44/Stefan_Dzierzek.jpg',
          desc: 'kleryk Stefan Dzierżek'
        },
        {
          id: 3,
          img: '/historia/okres_41_44/Romuald_Warakomski.jpg',
          desc: 'Romuald Warakomski „Hilary”'
        }
      ],
      part2:[
        {
          id: 4,
          img: '/historia/okres_41_44/Stanisław_Turski.jpg',
          desc: 'Stanisław Turski „Roman”'
        },
        {
          id: 5,
          img: '/historia/okres_41_44/Jozefa_Kafarska.jpg',
          desc: 'Józefa Kafarska „Wrzos”'
        },
        {
          id: 6,
          img: '/historia/okres_41_44/Stanisława_Kafarska.jpg',
          desc: 'Stanisława Kafarska „Hańcza”'
        },
        {
          id: 6,
          img: '/historia/okres_41_44/Zdzisław_Pleskaczewski.jpg',
          desc: 'Zdzisław Pleskaczewski „Zbyszek”'
        }
      ]
    },
    list:{
      kuznia:[
        'Kierownik placówki oraz warsztat wulkanizacyjny I dział druków - Michał Warakomski "Piotr"',
        'Grafika - Romuald Warakomski "Hilary".',
        'Fotografia - Stanisław Turski "Roman".',
        'Cynkografia - Stanisław Weber "Bohdan".',
        'Dział propagandy - Eudokia Bobaryko, Anna Bobaryko.',
        'Łączność - Irena Barszczewska "Lolka". „Gospoda”',
        'Kierownik placówki - Halina Turska "Aldona".',
        'Zespół biurowy - 3 osoby o nie ustalonych personaliach.',
        'Łączność - Halina Gierżunówna "Hanka", Józefa Rymkiewicz „Ziuta", Maria Rymkiewicz "Jaśmin" i Janina Doboszyńska.'
      ]
    }
  },
  tajne:{
    cards:[
      {
        id: 0,
        img: '/historia/okres_41_44/Stanislaw_Hiller.jpg',
        desc: 'Prof. Stanisław Hiller'
      },
      {
        id: 1,
        img: '/historia/okres_41_44/Janina_Bohdanowiczowna.jpg',
        desc: 'Janina Bohdanowiczówna'
      },
      {
        id: 2,
        img: '/historia/okres_41_44/Jan_Zelski.jpg',
        desc: 'Jan Żelski'
      },
      {
        id: 3,
        img: '/historia/okres_41_44/Michal_Reicher.jpg',
        desc: 'Prof. Michał Reicher'
      },
      {
        id: 4,
        img: '/historia/okres_41_44/Wladysław_Dziewulski.jpg',
        desc: 'Prof. Władysław Dziewulski'
      },
      {
        id: 5,
        img: '/historia/okres_41_44/Stefan_Ehrenkreutz.jpg',
        desc: 'Prof. Stefan Ehrenkreutz'
      }
    ],
    list:{
      osrodki:[
        'Ośrodek zwany uniwersyteckim, ponieważ wykładowcami byli również nauczyciele uniwersyteccy. Kierował nim prof. Władysław Dziewulski i Ananiasz Rojecki, prowadzący średnio 40 kompletów.',
        'Ośrodek prowadzony przez Janinę Bohdanowiczównę.',
        'Ośrodek kierowany przez Jana Żelskiego.'
      ],
      swiadectwa:[
        '1940/1941   -   10 osób',
        '1942/1943   -   25 osób',
        '1943/1944   -   18 osób',
        '1944/1945   -   9 osób.'
      ],
      profesorowie:[
        'Ludwik Chmaj - pedagogika',
        'Tadeusz Czeżowski - filozofia',
        'Konrad Górski - filologia polska',
        'Jan Oko i Stefan Srebrny - filologię klasyczną',
        'Janusz Iwaszkiewicz i Henryk Łowmiański - historię',
        'Olgierd Chomiński - filologię słowiańską',
        'mgr Gustaw Foss - filologię niemiecką'
      ],
      prof_mat_prz:[
        'Jan Pruffer - zoologię',
        'Władysław Dziewulski - astronomię',
        'Szczepan Szczeniowski - fizykę teoretyczną',
        'Julian Rudnicki - matematykę',
        'Edward Pasendorfer - geologię',
        'Edward Bekier - chemię fizyczną',
        'Leon Jasmanowicz - matematykę',
        'Irena Kardymowiczowa - krystalografię i mineralogię',
        'Stefan Kownas - botanikę',
        'Eugeniusz Michalski - chemię',
        'Henryk Nireodniczański - fizykę doświadczalną i teoretyczną'
      ]
    }
  },
  sluzby:[
    {
      id: 0,
      title: 'Pierwszymi świadczącymi na szerszą skalę opiekę lekarską byli:',
      list:[
        'Dr Maria Pietrusewiczowa',
        'Prof. dr Kazimierz Pelczar',
        'Dr Jerzy Dobrzański',
        'Dr Stanisław Markiewicz "Plus"'
      ],
      text: ''
    },
    {
      id: 1,
      title: 'Zorganizowana służba sanitarna pod nazwą Szefostwo Sanitarne Okręgu Wileńskiego, jako samodzielny pion organizacyjny Oddziału IV Sztabu Kwatermistrzostwa.',
      list:[
        'Pierwszym szefem sanitarnym został - dr Adam Galiński "Adam", "Pan P",',
        'Zastępcami - dr Stefan Borkowski, dr Wiktor Dunin- Horkawicz "Kamil", dr Stanisław Markiewicz "Pius",',
        'Szefem farmacji i zaopatrzenia w leki - mgr farm. Henryk Zajączkowski.'
      ],
      text: ''
    },
    {
      id: 2,
      title: 'W tym składzie zespół ten pracował od wiosny 1943 roku do wiosny 1943 roku. Jako naczelne zadania dla służb sanitarnych ustalono:',
      list:[
        'organizowanie służby sanitarnej w Wilnie i w terenie',
        'zapewnienie jej obsady personalnej i zaopatrywanie w środki medyczne',
        'organizowanie szkolenia sanitarnego dla przygotowania średniego personelu,',
        'opracowanie planu mobilizacyjnego w zakresie osobowym i materiałowym na wypadek powstania',
        'współpraca z Wydziałem Zdrowia Okręgowej Delegatury Rządu'
      ],
      text: ''
    },
    {
      id: 3,
      title: 'Właściwą opiekę lekarską, tego potrzebującym konspiratorom zapewniali wyznaczeni przez Komendę Okręgu Komendanci poszczególnych szpitali. Dyrektorami szpitali byli Niemcy, a Komendantami :',
      list:[
        'Szpitala Św. Jakuba - dr Feliks Oleński',
        'Szpitala kolejowy na Wilczej Łapie - dr Jan Janowicz',
        'Szpitala Czerwonego Krzyża na ul. Bogusławskiej - dr Zdzisław Kieturak',
        'Szpitala Neurologicznego przy ul. Witoldowej - doc. dr Janina Murynowicz',
        'Szpitala Zakaźnego na Zwierzyńcu - dr Zofia Wasilewska- Świdowa',
        'Lecznicy Ocznej Św. Józefa - dr Józef Kucharski',
        'Szpitala dla jeńców wojennych - dr Władysław Żemojtel "Znachor", "Biały Jan".'
      ],
      text: 'Szpital na Antokolu prowadził specjalistyczne szkolenia lekarzy w zakresie chirurgii, dla lekarzy brygadowych. Szkoleniem tym kierował prof., dr Kornel Michejda, przy cichej zgodzie niemieckiego dyrektora dr Reichelta. Tak zorganizowana służba sanitarna w szpitalach miejskich spełniała swoje zadania tym bardziej, że prawie cały personel pomocniczy stanowili Polacy w większości zaprzysiężeni żołnierze ZWZ- AK.'
    },
    {
      id: 4,
      title: 'W 1943 roku powołano służby sanitarne dla poszczególnych Inspektoratów.',
      list:[
        'Szefem sanitarnym Inspektoratu "A" został - dr Stefan Cierpiński "Korwin",',
        'Szefem sanitarnym Inspektoratu "BC" został - dr Wilhelm Berecki',
        'Szefem sanitarnym Inspektoratu "F" został - dr Maciej Brzozowski "Mietek", a po nim - dr Michał Holak "Bonifacy"',
        'Szefem sanitarnym Podokręgu Kowieńskiego - dr Adam Dowgird "Dominik".'
      ],
      text: ''
    },
    {
      id: 5,
      title: 'Do poszczególnych Brygad i Oddziałów Partyzanckich skierowywano lekarzy lub wyróżniających się wiadomościami studentów ostatnich lat studiów na Wydziale Lekarskim. Skierowani zostali do :',
      list:[
        '1. Brygady "Juranda" - dr Jan Rymian "Pean"',
        '2. Brygady "Kaziuka" - dr Bogdan Kopeć',
        '3. Brygady "Szczerbca" - dr Lech Iwanowski "Lancet"',
        '5. Brygady "Łupaszki" - dr Konstanty Pukjaniec "Strumyk"',
        '7. Brygady "Wilhelma" - dr Zygmunt Jastrzębski',
        '8. Brygady "Tura" - dr Anatoliusz Balc "Ponury"',
        '9. Brygady "Małego" - dr Zbroisław Haczkowski',
        '13. Brygady "Nietoperza" - dr Stanisław Żebrowski "Lancet I"',
        '24. Brygady "Wawrzeckiego" - dr Egeniusz Waszczuk'
      ],
      text: ''
    },
    {
      id: 6,
      title: 'Natomiast studenci do:',
      list:[
        '4. Brygady "Ronina" - Jan Mańkowski "Medyk"',
        '12. Brygady "Cerbera" - Zbigniew Szacki "Trus"',
        '23. Brygady "Ostrogi" Światołdycza" - Bohdan Buchowski',
        '36. Brygady "Wujka" - Michał Żołnierowicz'
      ],
      text: ''
    },
    {
      id: 7,
      title: 'Wiosną 1944 roku utworzono Szefostwo Sanitarnej Służby Polowej kierowaną przez prof. dr Michała Reichera "Sosna", któremu podlegali:',
      list:[
        'Szef sanitarny I Zgrupowania "Pohoreckiego" - dr Stefan Cierpiński "Korwin"',
        'Szef sanitarny II Zgrupowania "Węgielnego" - dr Tadeusz Ginko „Jan”',
        'Szef III Zgrupowania "Jaremy" - dr Mieczysław Pimpicki "Orzeł"'
      ],
      text: 'Sytuacja na foncie walk sowiecko - niemieckich wiosną 1944 roku wymagała przyśpieszenia przygotowań do czynnego uczestniczenia w Operacji "Burza" to jest wyzwalania przez Armię Krajową ziem położonych w granicach Państwa Polskiego, przed wkroczeniem wojsk sowieckich.'
    },
    {
      id: 8,
      title: 'Na potrzeby poszczególnych Zgrupowań Oddziałów Partyzanckich utworzono szpitale polowe.',
      list:[
        'I Zgrupowanie "Pohoreckiego" utworzyło szpital w Onżadowie koło Taboryszek oraz w Sorok Tatarach',
        'II Zgrupowanie "Węgielnego" utworzyło szpital w Prużanach nad Wilią oraz w Kalinie koło Rzeszy',
        'III Zgrupowanie utworzyło szpitale w leśniczówce koło Wielkich Wojsznaryszek i w Antoniszkach.'
      ],
      text: ''
    },
    {
      id: 9,
      title: 'Przy Zgrupowaniach działały również Czołówki Sanitarne noszące numer danego Zgrupowania.',
      list:[
        'Dla I Zgrupowania utworzona na bazie szpitala w Onżadowie kierowana przez dr Stefana Cierpińskiego "Korwin", natomiast chirurgiem w niej był dr Michał Juszczynski',
        'Czołówką II zgrupowana kierował dr Tadeusz Ginko, została ona utworzona na bazie szpitala w Prużanach.',
        'Czołówką III Zgrupowania utworzoną na bazie szpitala polowego w Antoniszkach, kierował dr Tadeusza Wiszniewskiego "Hel".',
        'Przy Komendzie Okręgu powstała Czołówka Sanitarna „K” z komendantem dr Władysławem Żemojtelem.'
      ],
      text: 'Konspiracyjna służba sanitarna Okręgu Wileńskiego była jedną z najlepiej zorganizowanych i najsprawniej działających służb pionu kwatermistrzowskiego. Pracujący w jej strukturach lekarze, felczerzy, pielęgniarki, sanitariusze, farmaceuci dobrze wypełnili swój ludzki, zawodowy i żołnierski obowiązek.'
    }
  ],
  odbitki:{
    list:[
      'Egz. Nr 1 - do akt',
      'Nr 2 i 3 - Oddział in. Bolszewików',
      'Nr 4 i 5 Oddział Suworowa',
      'Nr 6 Oddział Czapajewa',
      'Nr 8 Oddział im. Buciennego',
      'Nr 9 Oddział Ryżska',
      'Nr 10 Oddział im. Październikowej Rewolucji'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/models/historia/okres_41_44.js